
const InviteEmailFontsEnum = {
  Arial: 'Arial',
  CourierNew: 'Courier New',
  Georgia: 'Georgia',
  Verdana: 'Verdana',
  TimesNewRoman: 'Times New Roman',
  TrebuchetMS: 'Trebuchet MS',
};

export default Object.freeze(InviteEmailFontsEnum);
